const Section = ({title, children}) => <div className="bf-dashboard-section">
  <h2>{title}</h2>
  {children}
</div>

export default Section;